<template>
  <div class="myattend">
    <topmytitle :title1="titlework" />
    <van-tabs v-model="active">
      <van-tab title="考勤月历">
        <calendar
          :list="dateList"
          @click="getDate"
          @change="handleCalendarChange"
        />

        <van-cell-group v-if="date == allFullDate || date == ''">
          <p class="atten">
            {{ allFullDate }}
          </p>
          <div v-for="(item, index) in todayTime" :key="index">
            <van-cell title="打卡时间:" icon="clock-o">
              <template #right-icon>
                <span class="time-left">{{ item.eventTime | datefmt }}</span>
                <van-icon name="location-o" class="location-icon" /><span
                  class="location-address"
                  >{{ item.devName }}</span
                >
              </template>
            </van-cell>
          </div>
        </van-cell-group>
        <van-cell-group v-else-if="allFullDate > date && date >= beforeDate">
          <p class="atten">
            {{ date }}
            <!-- {{ date }} {{ attens.C_START_TM }} -->
            <!-- {{ !attens.C_START_TM ? "" : "-" }}
            {{ attens.C_END_TM }} -->
          </p>

          <div class="c20-del atten-box" v-if="attens.TYPECODE == '20'">
            <div class="box">异常</div>
          </div>
          <div
            class="c20-del atten-box"
            style="color: red"
            v-if="attens.TYPECODE == '20'"
          >
            <div>{{ attens.abnormalType }}</div>
          </div>
          <div
            class="c10-del atten-box"
            v-else-if="
              attens.TYPECODE == '10' ||
                attens.TYPECODE == '30' ||
                attens.TYPECODE == '50'
            "
          >
            <div class="box">正常</div>
          </div>
          <div class="c10-del atten-box" v-else>
            <div class="box"></div>
          </div>
          <div v-if="attens.C_ABS_TYPE">
            <div v-for="(item, index) in attens.C_ABS_TYPE" :key="index">
              <van-cell
                :title="item.C_ATTEN_TYPE_DESCR"
                :value="item.DURATION"
              />
            </div>
          </div>

          <van-cell title="上班打卡:" icon="clock-o">
            <template #right-icon>
              <span class="time-left">{{ attens.C_GO_CARD_DTTM }}</span>
              <van-icon name="location-o" class="location-icon" /><span
                class="location-address"
                >{{ attens.DESCR1 }}</span
              >
            </template>
          </van-cell>
          <van-cell title="下班打卡:" icon="clock-o">
            <template #right-icon>
              <span class="time-left">{{ attens.C_OFF_CARD_DTTM }}</span>
              <van-icon name="location-o" class="location-icon" /><span
                class="location-address"
                >{{ attens.DESCR2 }}</span
              >
            </template>
          </van-cell>
        </van-cell-group>
        <van-cell-group v-else>
          <p class="atten">
            {{ date }}
            <!-- {{ date }} {{ attens.C_START_TM }} -->
            <!-- {{ !attens.C_START_TM ? "" : "-" }}
            {{ attens.C_END_TM }} -->
          </p>

          <div class="c20-del atten-box" v-if="attens.TYPECODE == '20'">
            <div class="box">异常</div>
          </div>
          <div
            class="c20-del atten-box"
            style="color: red"
            v-if="attens.TYPECODE == '20'"
          >
            <div>{{ attens.abnormalType }}</div>
          </div>
          <div
            class="c10-del atten-box"
            v-else-if="
              attens.TYPECODE == '10' ||
                attens.TYPECODE == '30' ||
                attens.TYPECODE == '50'
            "
          >
            <div class="box">正常</div>
          </div>
          <div class="c10-del atten-box" v-else>
            <div class="box1"></div>
          </div>
          <div v-if="attens.C_ABS_TYPE">
            <div v-for="(item, index) in attens.C_ABS_TYPE" :key="index">
              <van-cell
                :title="item.C_ATTEN_TYPE_DESCR"
                :value="item.DURATION"
              />
            </div>
          </div>
          <van-cell
            title="上班打卡:"
            v-if="attens.TYPECODE == '20'"
            icon="clock-o"
          >
            <template #right-icon>
              <span class="time-left">{{ attens.C_GO_CARD_DTTM }}</span>
              <van-icon name="location-o" class="location-icon" /><span
                class="location-address"
                >{{ attens.DESCR1 }}</span
              >
            </template>
          </van-cell>
          <van-cell
            title="下班打卡:"
            v-if="attens.TYPECODE == '20'"
            icon="clock-o"
          >
            <template #right-icon>
              <span class="time-left">{{ attens.C_OFF_CARD_DTTM }}</span>
              <van-icon name="location-o" class="location-icon" /><span
                class="location-address"
                >{{ attens.DESCR2 }}</span
              >
            </template>
          </van-cell>
        </van-cell-group>
      </van-tab>

      <van-tab title="考勤情况汇总">
        <section class="menu">
          <div class="choosedate">
            <el-select
              v-model="selectValue"
              @change="selectType"
              placeholder="请选择"
              class="typeSelect"
            >
              <el-option
                v-for="item in selectOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div class="choosedate">
            <el-date-picker
              class="dateSelect"
              v-model="dateValue"
              type="month"
              placeholder="选择月"
              :clearable="false"
              format="yyyy年MM月"
              value-format="yyyy-MM"
              @change="selectDate"
            >
            </el-date-picker>
          </div>
        </section>
        <!--请假 -->
        <div v-if="setVacation">
          <section class="summary-collapse">
            <van-collapse v-model="activeNames" bind:change="onChange">
              <van-collapse-item name="1">
                <div class="col-title" slot="title">
                  {{ setVacation.DESC }}
                  <span class="slot-days">{{ setVacation.TOTAL }}</span>
                </div>
                <p
                  class="clock"
                  v-for="(item1, index1) in setVacation.DETAILS"
                  :key="index1"
                >
                  {{ item1.C_WORK_DATE }}
                  <span>{{ item1.TYPE }}{{ item1.DURATION }}</span>
                </p>
              </van-collapse-item>
            </van-collapse>
          </section>
        </div>
        <!-- 旷工-->
        <div v-if="setAbsenteeism">
          <section class="summary-collapse">
            <van-collapse v-model="activeNames" bind:change="onChange">
              <van-collapse-item name="2">
                <div class="col-title" slot="title">
                  {{ setAbsenteeism.DESC }}
                  <span class="slot-days">{{ setAbsenteeism.TOTAL }}</span>
                </div>
                <p
                  class="clock"
                  v-for="(item1, index1) in setAbsenteeism.DETAILS"
                  :key="index1"
                >
                  {{ item1.C_WORK_DATE }}
                  <span>{{ item1.TYPE }}{{ item1.DURATION }}</span>
                </p>
              </van-collapse-item>
            </van-collapse>
          </section>
        </div>

        <!-- setLate 迟到-->
        <div v-if="setLate">
          <section class="summary-collapse">
            <van-collapse v-model="activeNames" bind:change="onChange">
              <van-collapse-item name="4">
                <div class="col-title" slot="title">
                  {{ setLate.DESC }}
                  <span class="slot-days">{{ setLate.TOTAL }}</span>
                </div>
                <p
                  class="clock"
                  v-for="(item1, index1) in setLate.DETAILS"
                  :key="index1"
                >
                  {{ item1.C_WORK_DATE }}
                  <span>{{ item1.TYPE }}{{ item1.DURATION }}</span>
                </p>
              </van-collapse-item>
            </van-collapse>
          </section>
        </div>
        <!--setAbsent  缺勤-->
        <div v-if="setAbsent">
          <section class="summary-collapse">
            <van-collapse v-model="activeNames" bind:change="onChange">
              <van-collapse-item name="5">
                <div class="col-title" slot="title">
                  {{ setAbsent.DESC }}
                  <span class="slot-days">{{ setAbsent.TOTAL }}</span>
                </div>
                <p
                  class="clock"
                  v-for="(item1, index1) in setAbsent.DETAILS"
                  :key="index1"
                >
                  {{ item1.C_WORK_DATE }}
                  <span>{{ item1.TYPE }}{{ item1.DURATION }}</span>
                </p>
              </van-collapse-item>
            </van-collapse>
          </section>
        </div>
        <div class="blank"></div>
        <loading-show :isLoadindShow="loading"></loading-show>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
  import topmytitle from '../components/topmytitle';
  import LoadingShow from '../components/loading';
  import calendar from '../components/calendar/calendar2';
  import common from '../utils/common.js';
  import dateformat from '@/utils/dateformat';

  import {
    getAttendDataApi,
    calendarDataApi,
    businessTripApi,
    sameCalendarDataApi
  } from '../request/api';
  export default {
    name: 'myattend',
    data() {
      let month = new Date().getMonth() + 1;
      return {
        titlework: '我的考勤',
        activeNames: ['1'],
        active: 2,
        value1: '0',
        keyword: true,
        selectValue: '1',
        selectOptions: [
          { label: '全部', value: '1' },
          { label: '请假', value: '10' },
          { label: '迟到', value: '20' },
          { label: '早退', value: '30' },
          { label: '缺勤', value: '40' },
          { label: '旷工', value: '50' },
          { label: '出差', value: '60' }
        ],
        dateValue: new Date(),
        word1Data: '',
        todayTime: [],
        subBody: [],
        setVacation: [], //请假
        setAbsenteeism: [], //旷工
        setBusiness: [], //出差
        setLate: [], //迟到
        setAbsent: [], //早退
        dateList: [],
        arr: [],
        attens: {},
        noneData: {},
        date: '',
        attenClass: [],
        subBody1: [],
        index: '',
        value3: '',
        option3: [],
        loading: false,
        emptyShow: false,
        allFullDate: '',
        //dataShow: false,
        year: '',
        month: ''
      };
    },
    computed: {
      beforeDate() {
        let n = 3;
        let d = new Date();
        let year = d.getFullYear();
        let mon = d.getMonth() + 1;
        let day = d.getDate();
        if (day <= n) {
          if (mon > 1) {
            mon = mon - 1;
          } else {
            year = year - 1;
            mon = 12;
          }
        }
        d.setDate(d.getDate() - n);
        year = d.getFullYear();
        mon = d.getMonth() + 1;
        day = d.getDate();
        let s =
          year +
          '-' +
          (mon < 10 ? '0' + mon : mon) +
          '-' +
          (day < 10 ? '0' + day : day);
        return s;
      }
    },
    methods: {
      handleCalendarChange(date) {
        let timearr = date
          .replace(' ', ':')
          .replace(/\:/g, '-')
          .split('-');
        let timestr = '' + timearr[0] + '-' + timearr[1];
        // this.getDateList(date)
        this.getDateList(timestr);
      },
      getDate(date) {
        let _this = this;
        _this.date = date;
        if (this.arrData.length == 0) {
          _this.attens = {};
        }
        for (let i = 0; i < this.arrData.length; i++) {
          if (_this.date == this.arrData[i].C_WORK_DATE) {
            _this.attens = Object.assign({}, this.arrData[i]);

            break;
          } else {
            _this.attens = {};
          }
        }
      },

      same() {
        let params = {
          EMPLID: sessionStorage.getItem('EMPLID'),
          CAL_PRD: this.dateValue,
          TYPE: this.selectValue
        };
        let _this = this;
        _this.loading = true;
        getAttendDataApi(params).then(res => {
          if (res.CODE == 200) {
            if (res.DATA) {
              let { VACATION, ABSENTEEISM, BUSINESS, LATE, ABSENT } = res.DATA;

              _this.setVacation = VACATION;
              _this.setAbsenteeism = ABSENTEEISM;
              _this.setBusiness = BUSINESS;
              _this.setLate = LATE;
              _this.setAbsent = ABSENT;
            }
          }
          _this.loading = false;
        });
      },
      selectType() {
        this.same();
      },
      selectDate() {
        this.same();
      },
      getDateList(date) {
        sameCalendarDataApi({
          EMPLID: sessionStorage.getItem('EMPLID'),
          CARD_DATE: ''
        }).then(res => {
          if (res.CODE == 200) {
            this.todayTime = res.DATA;
          }
          // console.log(res, 's')
        });
        Promise.all([
          calendarDataApi({
            EMPLID: sessionStorage.getItem('EMPLID'),
            CAL_PRD: date
          }),
          businessTripApi({
            userCode: sessionStorage.getItem('EMPLID'),
            month: date
          })
        ]).then(res => {
          if (res[0].CODE == 200) {
            this.arrData = res[0].DATA;
          }
          if (res[1].code === 1000000) {
            res[1].data.forEach(item => {
              const existIndex = this.arrData.findIndex(
                subItem => subItem.C_WORK_DATE === item.tripDate
              );
              if (existIndex !== -1) {
                this.arrData[existIndex].TYPECODE = '20';
                this.arrData[existIndex].abnormalType = item.abnormalType;
              } else {
                this.arrData.push({
                  C_WORK_DATE: item.tripDate,
                  TYPECODE: '20',
                  abnormalType: item.abnormalType
                });
              }
            });
          }
          let arr = [];
          this.arrData.forEach(item => {
            let colorObj = {
              day: item.C_WORK_DATE,
              colors: [],
              bgColor: ''
            };
            if (item.TYPECODE) {
              arr.push(colorObj);
              let colorModel = common.getAttendanceModelWithType(item.TYPECODE);
              colorObj.colors.push(colorModel);
            }
          });
          this.dateList = arr;
        });
      }
    },
    components: {
      topmytitle,
      calendar,
      LoadingShow
    },
    created() {
      var myDate = new Date();
      this.year = myDate.getFullYear();
      this.month = myDate.getMonth() + 1;
      let myTimeData = myDate.getDate();
      if (this.month < 10) {
        this.month = '0' + this.month;
      }
      this.dateValue = this.year + '-' + this.month;
      myTimeData = myTimeData > 9 ? myTimeData : '0' + myTimeData;

      this.allFullDate = this.year + '-' + this.month + '-' + myTimeData;
      //console.log(this.allFullDate, 'allFullDate')
      this.same();
      // var time = myDate.toLocaleDateString().split('/').join('-')
      let time = this.year + '-' + this.month;
      this.getDateList(time);
    },
    filters: {
      number(val) {
        return (val / 60).toFixed(1);
      },
      word(val) {
        return val.slice(3, 5);
      },

      datefmt(val) {
        if (!val) return '';
        // let val = val.replace(' ', ':').replace(/\:/g, '-').split('-')
        return dateformat('hh:mm', new Date(val.replace(/-/g, '/')));
      }
    }
  };
</script>
<style lang="less" scoped>
  .menu {
    display: flex;
    border-top: 1px solid #e5e5e5;
    div {
      width: 50%;
      box-shadow: 0;
    }
    .choosedate {
      background: white;
      height: 48px;
      line-height: 48px;
      text-align: center;
      color: #323233;
      font-size: 15px;
    }
    .choosedate:after {
      display: inline-block;
      content: '';
      position: relative;
      top: 2px;
      margin-left: 3px;
      width: 0;
      height: 0;
      border: 5px solid transparent;
      border-top-color: #999;
    }
    .typeSelect {
      width: 30px;
      /deep/ .el-input__inner {
        border: none;
        padding: 0;
      }
      /deep/ .el-input__suffix {
        display: none;
      }
    }
    .dateSelect {
      width: 80px;
      /deep/ .el-input__inner {
        border: none;
        padding: 0;
      }
      /deep/ .el-input__prefix {
        display: none;
      }
    }
  }
  /deep/ .van-calendar__header-title {
    display: none;
  }
  /deep/ .van-tabs__line {
    width: 50%;
    background: #007fc6;
    height: 2px;
  }
  /deep/ .van-tab--active {
    color: #007fc6;
    font-weight: bold;
  }
  /deep/ .van-tab {
    font-size: 15px;
  }
  .makeup {
    position: fixed;
    bottom: 0;
    height: 44px;
    width: 100%;
    text-align: center;
    line-height: 44px;
    color: white;
    background: #007fc6;
    font-size: 18px;
  }
  .slot-days {
    float: right;
    color: #b2b2b2;
    font-size: 16px;
  }
  .summary-collapse {
    margin: 10px 16px 0;
    padding: 5px 10px;
    background: white;
    border-radius: 10px;
    .col-title {
      font-size: 16px;
    }
    .clock {
      line-height: 44px;
      color: #8f8f8f;
      font-size: 16px;
      border-bottom: 1px dotted #aeb5c2;
      display: flex;
      justify-content: space-between;
      span {
        float: right;
        font-size: 16px;
        color: black;
      }
    }
  }
  .summary {
    margin: 10px 16px 0;
    padding: 5px 10px;
    background: white;
    border-radius: 10px;
    div {
      display: flex;
      line-height: 44px;
      border-bottom: 1px dotted #aeb5c2;
      font-size: 16px;
      p {
        flex: 1;
      }
      span {
        margin-left: 10px;
        color: #8f8f8f;
        font-size: 15px;
      }
      .expand {
        color: #2c7ef6;
        font-size: 13px;
      }
    }
    .clock {
      line-height: 44px;
      color: #8f8f8f;
      font-size: 13px;
      span {
        float: right;
        font-size: 15px;
        color: black;
      }
    }
  }
  .blank {
    height: 60px;
    width: 100%;
  }
  .atten {
    padding: 10px 16px;
    border: 1px solid #f8f8f8;
    font-size: 15px;
    color: #323233;
  }
  .atten-box {
    display: flex;
    justify-content: flex-start;
    width: 90%;
    margin: 0 auto;
    padding-bottom: 10px;
    .box {
      color: #323233;
      font-size: 15px;
      width: 100%;
    }
    .box::before {
      display: inline-block;
      content: '';
      padding: 8px 8px;
      margin-right: 3%;
      position: relative;
      top: 15%;
    }
  }
  .time-left {
    padding-right: 14%;
    font-size: 15px;
  }
  .location-address {
    font-size: 15px;
    width: 45%;
    display: inline-block;
  }
  .location-icon {
    font-size: 16px;
    padding-top: 3px;
    color: #00cd16;
  }
  .c10-del {
    .box::before {
      background-color: #00cd66;
    }
  }

  .c20-del {
    .box::before {
      background-color: #e92b21;
    }
  }
</style>
